import { State } from 'modules';

export const loadAuditPending = (state: State) => state.audit.loadAuditPending;
export const loadAudPending = (state: State) => state.audit.loadAuditPending;

export const loadMoreAuditPending = (state: State) =>
  state.audit.loadAuditPending;

export const allAuditLoaded = (state: State) => state.audit.allAuditLoaded;
export const auditList = (state: State) => state.audit.auditList;
export const auditFilters = (state: State) => state.audit.filters;
export const auditsListLoaded = (state: State) => state.audit.auditListLoaded;
